import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {TerminalSearchModel} from "../terminal-search.model";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {TerminalSearchPageComponent} from "../terminal-search-page/terminal-search-page.component";
import {TerminalEditPageComponent} from "../terminal-edit-page/terminal-edit-page.component";

@Component({
    selector: "wbo-terminal-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TerminalMultiSelectEditControlComponent),
        provideSearchModel(TerminalSearchModel)
    ]
})
export class TerminalMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<TerminalSearchModel> implements OnInit {
    @Input() typeFilter: string;

    constructor(model: TerminalSearchModel, injector: Injector) {
        super(model, injector, "terminalId", "name", true);

        this.extendedSearchComponent = TerminalSearchPageComponent;
        this.extendedEditComponent = TerminalEditPageComponent;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.model.filter["type"] = this.typeFilter;
    }

    override onOptionOpen(option: any) {
        this.selectControlComponent.openView(option);
    }
}
